<template>
  <div class="rechnungsausgang card">
    <div class="rechnungseingang_title">
      {{ title }}
    </div>
    <div class="rechnungseingang_value value">
      {{ value }}
    </div>
  </div>
</template>

<script>
export default {
  name: "Card",

  props: {
    title: {
      type: String,
      required: true,
    },

    value: {
      type: Number,
      required: true,
    },
  },
};
</script>

<style>
.rechnungseingang_title {
  margin-top: -15px;
}
</style>